// extracted by mini-css-extract-plugin
export default {"title":"xMqsRPXN1jgIFH3vv9JZ"};